// Copyright (c) 2017 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export const getColumnDefinitions = () =>
    [
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'description',
            field: 'description',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DESCRIPTION'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'pipCompletionStatus',
            field: 'pipCompletionStatus.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIP_COMPLETION_STATUS'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'pipNumber',
            field: 'pipNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIP_NUMBER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'type',
            field: 'type.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('TYPE'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'participant',
            field: 'participant.value',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PARTICIPANT'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'expireDate',
            field: 'expireDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerLeftClassName,
            headerName: translate('EXPIRES'),
            width: 200
        }
    ];



// WEBPACK FOOTER //
// ./src/reports/pip-history/report-services/column-definitions.js